import { render, staticRenderFns } from "./ButtonBorderedIconOptions.vue?vue&type=template&id=23e9dd3d&scoped=true&"
import script from "./ButtonBorderedIconOptions.vue?vue&type=script&lang=js&"
export * from "./ButtonBorderedIconOptions.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBorderedIconOptions.vue?vue&type=style&index=0&id=23e9dd3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9dd3d",
  null
  
)

export default component.exports